export default __webpack_public_path__ + "static/media/peacock.89e2d0f4.png";